import { LwApiPM } from "@techniaorg/liteweb-api";
import { waitForIFrameAndModel } from "../src/util";

// Wait until the iframe is loaded
const myframe = document.querySelector("iframe#webviewer") as HTMLIFrameElement;
let LwAPI: LwApiPM | null = null;
const apiReady: Promise<LwApiPM | null> = waitForIFrameAndModel(myframe)
  .then((api) => {
    LwAPI = api;
    return api;
  })
  .catch((e) => {
    console.log("LwAPI could not be initialized: ", e);
    return null;
  });

function ex_setnodevisibility(str: string) {
  LwAPI?.getTree().then(function (tree) {
    FoundNodes = [];
    if (Array.isArray(tree)) {
      FindNodeRec(tree[0].root.children, "text", str);
    } else FindNodeRec(tree.root.children, "text", str);

    LwAPI?.setNodeVisibility("1:1", false);

    FoundNodes.forEach(function (item) {
      LwAPI?.setNodeVisibility(item, true);
    });
  });
}

var FoundNodes: any[] = [];
function FindNodeRec(obj: any, key: any, val: any) {
  // obj should be initially tree.root.children, on recursion tree.root.children[i].children
  for (var i = 0; i < obj.length; i++) {
    if (obj[i][key].toLowerCase().indexOf(val.toLowerCase()) > -1) {
      // @ts-ignore
      FoundNodes.push(obj[i].id);
    }
    if (typeof obj[i].children == "object") {
      var childObj = obj[i].children;
      FindNodeRec(childObj, key, val);
    }
  }
}

document.getElementById("showElements")?.addEventListener("click", async () => {
  await apiReady;
  const findStr = (document.getElementById("findstr") as HTMLInputElement)
    .value;
  ex_setnodevisibility(findStr);
});
